import { FrequencyParameter } from "src/app/api/asset/technical-details/frequency-parameter";

export class EditFrequencyModel {
    IeClass50Hz?: string | null;
    PartialLoad50Percent50Hz?: number | null;
    PartialLoad75Percent50Hz?: number | null;
    FullLoad50Hz?: number | null;
    IeClass60Hz?: string | null;
    PartialLoad50Percent60Hz?: number | null;
    PartialLoad75Percent60Hz?: number | null;
    FullLoad60Hz?: number | null;

    static fromEntity(data: FrequencyParameter[]): EditFrequencyModel {
        const model = new EditFrequencyModel();

        const freq50 = data.find(x => x.frequency == 50);
        if(freq50 != null) {
            model.IeClass50Hz = freq50.ieClass;
            model.PartialLoad50Percent50Hz = freq50.loads[0].value;
            model.PartialLoad75Percent50Hz = freq50.loads[1].value;
            model.FullLoad50Hz = freq50.loads[2].value;
        }

        const freq60 = data.find(x => x.frequency == 60);
        if(freq60 != null) {
            model.IeClass60Hz = freq60.ieClass;
            model.PartialLoad50Percent60Hz = freq60.loads[0].value;
            model.PartialLoad75Percent60Hz = freq60.loads[1].value;
            model.FullLoad60Hz = freq60.loads[2].value;
        }

        return model;
    }

    toEntity(): FrequencyParameter[] {
        return [
            {
                frequency: 50,
                ieClass: this.IeClass50Hz ?? "",
                loads: [
                    { load: 50, value: this.PartialLoad50Percent50Hz ?? 0 },
                    { load: 75, value: this.PartialLoad75Percent50Hz ?? 0 },
                    { load: 100, value: this.FullLoad50Hz ?? 0 }
                ]
            },
            {
                frequency: 60,
                ieClass: this.IeClass60Hz ?? "",
                loads: [
                    { load: 50, value: this.PartialLoad50Percent60Hz ?? 0 },
                    { load: 75, value: this.PartialLoad75Percent60Hz ?? 0 },
                    { load: 100, value: this.FullLoad60Hz ?? 0 }
                ]
            }
        ];
    }
}